'use client';

import clsx from 'classnames';
import CloseNav from 'icons/lib/close_nav.svg';
import Link from 'next/link';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { MouseEvent } from 'react';
import { useRef } from 'react';

import { useTranslation } from '@/i18n/client';
import { Logo } from '@/shared/components/logo';
import { useCurrentLocale } from '@/shared/utils/client';

import { MultilevelSidebar } from '../multilevelSidebar';
import styles from './HeaderSidebar.module.scss';
import { HeaderSidebarProps } from './types';

export function HeaderSidebar({
  sidebarMenu,
  open,
  topMenu,
  onCloseButtonPress,
  setOpen,
}: HeaderSidebarProps) {
  const router = useRouter();
  const { t } = useTranslation(['header']);
  const navRef = useRef<HTMLDivElement>(null);
  const params = useSearchParams();
  const locale = useCurrentLocale();

  const navClassNames = clsx(styles.headerSidebarContent, {
    // [styles.headerSidebarContentOpen]: open.length > 0,
  });

  const onCloseButtonClick = (event: MouseEvent) => {
    event.preventDefault();
    onCloseButtonPress?.();
  };

  useEffect(() => {
    if (!navRef.current) {
      return;
    }

    if (open.length === 1) {
      navRef.current.scrollTo({ top: 0 });
      navRef.current.style.overflowY = 'hidden';
      return;
    }

    if (open.length === 0) {
      navRef.current.style.overflowY = 'auto';
    }
  }, [open]);

  return (
    <>
      <div className={styles.headerSidebarTopBar}>
        <Link
          prefetch={false}
          className={styles.headerSidebarTopBarLogo}
          href="/"
        >
          <Logo />
        </Link>

        <Link prefetch={false} href="#" onClick={onCloseButtonClick}>
          <CloseNav />
        </Link>
      </div>

      <nav className={navClassNames} ref={navRef}>
        <MultilevelSidebar
          items={sidebarMenu?.content || []}
          open={open}
          onCloseButtonPress={onCloseButtonPress}
          setOpen={setOpen}
        />

        <ul className={styles.headerSidebarLinks}>
          {!!topMenu?.content?.length &&
            topMenu?.content?.map((link, index) => (
              <Link prefetch={false} key={index} href={link.url ?? '#'}>
                <li>
                  <span>{link?.label}</span>
                </li>
              </Link>
            ))}
        </ul>
      </nav>
    </>
  );
}
